import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useEffect } from "react";

interface NavbarProps {
  isLoggedIn: boolean;
  modules: { id: number; title: string; url: string }[];
  handleLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isLoggedIn, handleLogout }) => {
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

  useEffect(() => {
    if ((window as any).Webflow) {
      (window as any).Webflow.destroy();
      (window as any).Webflow.ready();
      (window as any).Webflow.require("navbar").ready();
    }
  }, []);
  

  return (
    <>
      <div data-animation="default" data-collapse="small" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" className="navbar w-nav">
        <div className="div-block-31">

          <div className="menu-button w-nav-button navbar-menu-btn">
            <div className="w-icon-nav-menu"></div>
          </div>

          <Link to="/" className="brand w-nav-brand navbar-brand">
            <img
              src="images/myKixstore.png"
              loading="lazy"
              alt=""
              sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 852px) 100vw, 852px"
              srcSet="images/myKixstore.png 500w, images/myKixstore.png 800w, images/myKixstore.png 852w"
              className="image-23"
            />
          </Link>

            <nav role="navigation" className="nav-menu-2-copy w-nav-menu navbar-nav">
              {!isLoggedIn ? (
                <>
                  <Link to="/login" className="nav-link w-nav-link">Sign in</Link>
                  <Link to="/signup" className="coa-button-nav w-button">Create Your Own Store</Link>
                </>
              ) : (
                <>
                {(currentRole==1) ? (
                  <NavLink to="/payment-batches" className={({ isActive }) => `nav-link w-nav-link${isActive ? " w--current" : ""}`}>Payment Batches</NavLink>
                ) : ""}
                {(currentRole==1) ? (
                  <NavLink to="/admin-dashboard" className={({ isActive }) => `nav-link w-nav-link${isActive ? " w--current" : ""}`}>Stores</NavLink>
                ) : (
                  <NavLink to="/dashboard" className={({ isActive }) => `nav-link w-nav-link${isActive ? " w--current" : ""}`}>Orders</NavLink>
                )}
                {(currentRole==1) ? (
                  <NavLink to="/orders" className={({ isActive }) => `nav-link w-nav-link${isActive ? " w--current" : ""}`}>All Orders</NavLink>
                ) : ""}
                <NavLink to="/edit-profile" className={({ isActive }) => `nav-link w-nav-link${isActive ? " w--current" : ""}`}>Edit Profile</NavLink>
                <Link to="/" onClick={handleLogout} className="nav-link w-nav-link">Logout</Link>
                </>
              )}
            </nav>

        </div>
      </div>
    </>
  );
};

export default Navbar;
